<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Fees Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <a :href="path" style="color: yellow;" target="blank">
                    Payment Policy!!!
                </a>
            </v-toolbar>
            <v-row justify="center">
                <v-tooltip top color="warning">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="red" outlined rounded class="button issue-btn" v-bind="attrs" v-on="on" @click="dialog_issue = true">
                            <span class="button-name">
                                Amount deducted but receipt not generated. click here
                            </span>
                        </v-btn>
                    </template>
                    <span> Steps to raise dispute. </span>
                </v-tooltip>
            </v-row>

            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="selected_ay"
                        item-value="ay_id"
                        :items="academic_year_list"
                        item-text="academicyear"
                        label="Select Academic Year"
                        outlined
                        @click="
              show = false;
              cleardata();
            "
                        persistent-hint
                        hint="Please Select Academic Year"
                    />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-combobox color="#0f2027" rounded v-model="selected_children" :items="children" label="Select Child" item-text="name" outlined dense prepend-icon="mdi-account-child-circle" @click="show = false"></v-combobox>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn class="button" @click="getDetails()">Proceed</v-btn>
                </v-col>
            </v-row>
            <span v-if="show == true">
                <span v-if="learner_info != null">
                    <div class="scroll" v-if="show_out == 'YES'">
                        <v-simple-table v-if="show_out == 'YES'" dense class="elevation-1" fixed-header>
                            <thead>
                                <tr>
                                    <th class="">Name</th>
                                    <th class="">Standard</th>
                                    <th class="">Division</th>
                                    <th class="" v-for="header in ay_header" :key="header">
                                        <center>{{ header }}</center>
                                    </th>
                                    <th class="">Total Outstanding</th>
                                    <th class="">Paid Outstanding</th>
                                    <th class="">Remaining Outstanding</th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <tr v-for="(s, index) in learner_info" :key="index">
                                    <td>{{ s.name }}</td>
                                    <td>{{ s.leaner_std }}</td>
                                    <td>{{ s.leaner_div }}</td>
                                    <td v-for="header in s.out_amt" :key="header">
                                        {{ header }}
                                    </td>
                                    <td>
                                        <strong> {{ all_total_amount }}</strong>
                                    </td>
                                    <td>
                                        <strong>{{ all_total_paid }}</strong>
                                    </td>
                                    <td>
                                        <strong>{{ all_total_remaining }}</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </span>
                <v-row justify="center">
                    AY ::{{ current_ay }} || Standard :: {{ leaner_std }} || Division :: {{ leaner_div }}
                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table dense class="elevation-1 mytable">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Academic Year</th>
                                        <th>Name</th>
                                        <th>Total Amount</th>
                                        <th>Paid Amount</th>
                                        <th>Remaining Amount</th>
                                        <th>Weekly Fine (If Applicable)</th>
                                        <th>Fine Start Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in outstanding_details_list" :key="index">
                                        <td>{{ item.of_academicyear }}</td>
                                        <td>
                                            <strong>{{ item.name }}</strong>
                                        </td>
                                        <td>{{ item.fee }}</td>
                                        <td>{{ item.paid_fee }}</td>
                                        <td>{{ item.balnace_fee }}</td>
                                        <td>{{ item.fine }}</td>
                                        <td>{{ item.due_date }}</td>
                                        <!-- <td>
                                            <strong>{{ item.balnace_fee }}</strong>
                                        </td> -->
                                    </tr>
                                    <tr v-for="(item, index) in installment_details_list" :key="index">
                                        <td>{{ item.of_academicyear }}</td>
                                        <td>
                                            <strong>{{ item.name }}</strong>
                                        </td>
                                        <td>{{ item.fee }}</td>
                                        <td>{{ item.paid_fee }}</td>
                                        <td>{{ item.balnace_fee }}</td>
                                        <td>{{ item.fine }}</td>
                                        <td>{{ item.due_date }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                
                <!-- <v-row justify="center">
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            multiple
                            required
                            v-model="inst_id"
                            return-object
                            :items="installment_list"
                            item-text="name"
                            label="Select Installments"
                            outlined
                            persistent-hint
                            hint="Please Select installments"
                        />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn
                            class="button"
                            @click="
                getmatrix();
              "
                        >
                            Get Fee Details
                        </v-btn>
                    </v-col>
                </v-row> -->
                
                <v-row
                    v-if="unpaidInstallments.length"
                    align="center"
                    justify="center"
                    class="mt-4"
                    >
                    <v-col
                        cols="12"
                        md="auto"
                        class="d-flex justify-center align-center flex-wrap"
                    >
                        <v-checkbox
                            v-for="(inst, index) in unpaidInstallments"
                            :key="inst.id"
                            v-if="isVisible(index)"
                            v-model="inst_id"
                            :label="inst.name"
                            :value="inst"
                            color="#0F2027"
                            class="mx-3"
                            @change="onToggle(inst, index)"
                        />
                    </v-col>
                    <v-col
                        cols="12"
                        md="2"
                        class="d-flex justify-center pt-0"
                    >
                        <v-btn
                        class="button ma-0"
                        
                        @click="getmatrix()"
                        >
                        Get Fee Details
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-if="matrix_list != ''">
                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table dense class="elevation-1 mytable">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Fees Component</th>
                                        <th>Total Amount</th>
                                        <th>Paid Amount</th>
                                        <th>Remaining Amount</th>
                                        <th>Amount To Pay</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in matrix_list" :key="item.lid">
                                        <td>{{ item.feescomponentacademicyear }}</td>
                                        <td>{{ item.amount }}</td>
                                        <td>{{ item.paid_till_now }}</td>
                                        <td>{{ item.reamining }}</td>
                                        <td>{{ item.amount_pay }}</td>
                                    </tr>
                                    <tr class="toolbar noborder">
                                        <td class="noborder toolbar"></td>
                                        <td class="noborder toolbar"></td>
                                        <td class="noborder toolbar"></td>
                                        <td class="noborder toolbar">
                                            <span v-if="total_amount != 0">Fine :: {{ fine }} </span>
                                        </td>
                                        <td class="noborder toolbar">
                                            Total Amount To Pay :: {{ total_amount }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row v-if="matrix_list != ''" justify="center">
                    <v-col cols="12" sm="2" md="2">
                        <span class="text-color1">Total Fees :: {{ fees_amount }}</span>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <span class="text-color2">Paid Fees :: {{ paid_amount }}</span>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="total_amount != 0">
                        <span class="text-color">Fine :: {{ fine }}</span>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <span class="text-color">Remaining Fees :: {{ total_amount }}</span>
                    </v-col>
                </v-row>
                <span class="flash" v-if="matrix_list != '' && total_amount != 0">
                    <strong>
                        <center>
                            Please do not REFRESH or CLOSE ERP page at the time of transaction
                        </center>
                    </strong>
                </span>
                <v-row justify="center" v-if="matrix_list != ''">
                    <!-- {{installment_pg_list}} -->
                    <form :action="url" v-if="pg_hidden != null && pgs.includes('PayTM')" @submit="payment" name="paytmform" method="POST">
                        <input type="hidden" :value="pg_hidden.orgid" name="orgid" />
                        <input type="hidden" :value="pg_hidden.tenantid" name="tenantid" />
                        <input type="hidden" :value="pg_hidden.uid" name="uid" />
                        <input type="hidden" :value="pg_hidden.studid" name="studid" />
                        <input type="hidden" :value="pg_hidden.ay" name="ay" />
                        <input type="hidden" :value="total_amount" name="fee_amount" />
                        <input type="hidden" :value="installment_pg_list" name="purpose" />
                        <input type="hidden" :value="matrix_pg_list" name="json_pre_trans_data" />
                        <input type="hidden" :value="pg_hidden.hash_val" name="hash_val" />
                        <v-btn class="button" :loading="pg_loader" v-if="total_amount != 0" type="submit">Pay Online (Paytm)</v-btn>
                    </form>
                    <v-btn class="button" :loading="pg_loader" v-if="pg_hidden != null && pgs.includes('BillDesk') && total_amount != 0" type="submit" @click="payFees()">Pay Online(Bill Desk)</v-btn>
                </v-row>
                <span v-if="matrix_list != '' && total_amount != 0">
                    <strong>
                        <center>
                            Standard charges will apply, based on Mode of Payment
                        </center>
                    </strong>
                </span>
            </span>
        </v-card>
        <v-dialog v-model="dialog_outsatnding" fullscreen>
            <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong> Student Otstanding Fees </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog_outsatnding = false"><v-icon> mdi-close </v-icon></v-btn>
                </v-toolbar>
                <student-outstanding-fees :selected_children="selected_children"></student-outstanding-fees>
                <v-row justify="center">
                    <v-btn class="button no-display" @click="dialog_outsatnding = false">Cancel</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_issue" persistent max-width="1500px">
            <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong> Raise Dispute </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog_issue = false"><v-icon> mdi-close </v-icon></v-btn>
                </v-toolbar>
                <v-col cols="12" sm="12" md="`12">
                    <center>
                        You can raise dispute, if amount is deducted from your bank, but receipt is not generated. <br />
                        Click on "Proceed", which will redirect to Payment History Page where you can raise dispute for that transaction. <br />
                        Refer below figure for the same.
                        <img :src="history" width="100%" height="100%" alt="logo" />
                    </center>
                </v-col>
                <v-row justify="center">
                    <v-btn class="button">
                        <router-link style="text-decoration: none; color: black;" :to="{ name: 'parent-fee-history' }" class="root">
                            Proceed
                        </router-link>
                    </v-btn>
                    <v-btn class="button no-display" @click="dialog_issue = false">Cancel</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    import StudentOutstandingFees from "../Parent/StudentOutstandingFees";
    export default {
        name: "StudentOutstandingFees",
        components: {
            "student-outstanding-fees": StudentOutstandingFees,
        },
        data: () => ({
            child_info: null,
            children: [],
            selected_install: [],
            get_component_installmet_list: [],
            show: false,
            dialog_outsatnding: false,
            selected_children: "",
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            current_ay: "",
            search: "",
            s3url: "",
            leaner_std: null,
            leaner_div: null,
            installment_list: [],
            inst_id: [],
            matrix_list: [],
            total_amount: "",
            paid_amount: "",
            fees_amount: "",
            debit_card_charges: "",
            credit_card_charges: "",
            netbanking_card_charges: "",
            fine: "",
            display_flag: false,
            matrix_pg_list: null,
            dialog_issue: false,
            pg_hidden: null,
            pg_loader: false,
            path: null,
            total_outstanding: null,
            paid_outstanding: null,
            remaining_outstanding: null,
            outstanding: null,
            installment_details_list: [],
            outstanding_details_list: [],
            academic_year_list: [],
            installment_pg_list: [],
            selected_ay: null,

            //added 18-04-22
            learner_info: null,
            ay_header: null,
            all_total_amount: null,
            all_total_paid: null,
            all_total_remaining: null,
            history: null,
            show_out: null,
            billdeskMsg: null,
            pgs: []
        }),
        created() {
            // this.url=process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm"
            this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm";
        },
         computed: {
            unpaidInstallments() {
                return this.installment_details_list
                .filter(i => i.balnace_fee > 0)
                .sort((a, b) => a.id - b.id); // or by due_date if needed
            },
        },
        methods: {

            payFees() {
                this.pg_loader = true

                const formData = {
                    fee_amount: this.total_amount,
                    purpose: this.installment_pg_list,
                    tenantid: this.pg_hidden.tenantid,
                    orgid: this.pg_hidden.orgid,
                    ay: this.pg_hidden.ay,
                    uid: this.pg_hidden.uid,
                    studid: this.pg_hidden.studid,
                    json_pre_trans_data: this.matrix_pg_list,
                    hash_val: this.pg_hidden.hash_val,
                    payment_type: "INSTALLMENT"
                }

                axios.post("/paymentGatewayBillDesk/initiateBillDeskPayment", formData)
                    .then(res => {
                        if (res.data.msg == "200") {
                            this.billdeskMsg = res.data.billdeskMsg
                            this.startBillDesk()
                        } else {
                            this.showSnackbar("red", res.data.msg || "BillDesk init failed")
                        }
                    })
                    .catch(() => {
                        this.showSnackbar("red", "Server error")
                    })
                    .finally(() => {
                        this.pg_loader = false
                    })
            },

            startBillDesk() {
                if (!this.billdeskMsg) {
                    this.showSnackbar("red", "Payment data missing")
                    return
                }

                bdPayment.initialize({
                    msg: this.billdeskMsg,
                    options: {
                        enableChildWindowPosting: true,
                        enablePaymentRetry: true,
                        retry_attempt_count: 2
                    }
                });
            },

            isVisible(index) {
                if (index === 0) return true
                return this.inst_id.some(
                i => i.id === this.unpaidInstallments[index - 1].id
                )
            },

            onToggle(inst, index) {
                const exists = this.inst_id.some(i => i.id === inst.id)
                    if (!exists) {
                    const allowedIds = this.unpaidInstallments
                        .slice(0, index)
                        .map(i => i.id)

                    this.inst_id = this.inst_id.filter(i =>
                        allowedIds.includes(i.id)
                    )
                }
            },
            cleardata() {
                this.matrix_list = [];
                this.installment_pg_list = [];
                this.matrix_pg_list = [];
                this.current_ay = null;
                this.leaner_std = null;
                this.leaner_div = null;
                this.installment_list = [];
                this.installment_details_list = [];
                this.outstanding_details_list = [];
                this.outstanding = null;
                this.inst_id = [];
                this.matrix_list = [];
                this.installment_pg_list = [];
                this.matrix_pg_list = [];
            },
            payment() {
                var formData = new FormData(paytmform);
                this.pg_loader = false;
            },
           
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getmatrix() {
                //alert(this.inst_id)
                this.matrix_list = [];
                this.installment_pg_list = [];
                this.matrix_pg_list = [];
                const formData = {
                    inst_id: this.inst_id,
                    child: this.selected_children.id,
                    ay: this.selected_ay,
                };
                axios
                    .post("/AccountingAndFees/getmatrix_new_multiple", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.matrix_list = res.data.matrix_list;
                            this.total_amount = res.data.total_amount;
                            this.paid_amount = res.data.paid_amount;
                            this.fees_amount = res.data.fees_amount;
                            this.debit_card_charges = res.data.debit_card_charges;
                            this.credit_card_charges = res.data.credit_card_charges;
                            this.netbanking_card_charges = res.data.netbanking_card_charges;
                            this.fine = res.data.fine;
                            this.pg_hidden = res.data.pg_hidden;
                            this.matrix_pg_list = JSON.stringify(this.pg_hidden.json_pre_trans_data);
                            this.installment_pg_list = this.pg_hidden.installment_pg_list;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            getDetails() {
                this.current_ay = null;
                this.leaner_std = null;
                this.leaner_div = null;
                this.installment_list = [];
                this.installment_details_list = [];
                this.outstanding_details_list = [];
                this.outstanding = null;
                this.inst_id = [];
                this.matrix_list = [];
                this.installment_pg_list = [];
                this.matrix_pg_list = [];
                const formData = {
                    child: this.selected_children.id,
                    ay: this.selected_ay,
                };
                axios
                    .post("/AccountingAndFees/getPaymentInfo", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            // if(res.data.flag_fee == "YES"){
                            if (res.data.flag == "YES") {
                                this.show = true;
                                this.current_ay = res.data.current_ay;
                                this.leaner_std = res.data.leaner_std;
                                this.leaner_div = res.data.leaner_div;
                                this.installment_list = res.data.installment_list;
                                this.installment_details_list = res.data.installment_details_list;
                                this.outstanding_details_list = res.data.outstanding_details_list;
                                this.outstanding = res.data.outstanding;
                                this.show_out = res.data.show_out;
                                this.pgs = res.data.pgs

                                // for(var i=0;i<this.installment_details_list.length;i++){
                                //     if(this.installment_details_list[i].balnace_fee==0){
                                //         alert("00000"+this.installment_details_list[i].id+"----"+this.installment_details_list[i].name)
                                //         alert("iiiiii"+this.installment_list[i].id+"----"+this.installment_list[i].name)
                                //         this.installment_list.splice(i, 1);
                                //     }
                                // }


                                for (var i = 0; i < this.installment_details_list.length; i++) {
                                    if (this.installment_details_list[i].balnace_fee == 0) {
                                        var details_id = this.installment_details_list[i].id;
                                        for (var j = 0; j < this.installment_list.length; j++) {
                                            if (this.installment_list[j].id === details_id) {
                                                // Remove the matching object from installment_list
                                                this.installment_list.splice(j, 1);
                                                break; // Exit the loop after removing the matching object
                                            }
                                        }
                                    }
                                }
                               

                                //added 18-04-22
                                this.learner_info = res.data.learner_info;
                                this.ay_header = res.data.ay_header;
                                this.all_total_amount = res.data.all_total_amount;
                                this.all_total_paid = res.data.all_total_paid;
                                this.all_total_remaining = res.data.all_total_remaining;
                            } else if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", res.data.snackbar);
                            }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            //alert("this.s3url::"+this.s3url)
            let org_id = localStorage.getItem("EPS-tenant");
            this.history = "https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/payment_history.jpeg";

            if (org_id == "zeal") {
                this.path = null;
            } else if (org_id == "sbpps") {
                this.path = "https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/Documents/S.B.P.P.S+Cancellation+Policy+++2021-22.pdf";
            } else if (org_id == "wws") {
                this.path = "https://wws-schoolerp.s3.ap-south-1.amazonaws.com/documents/wws_payment_policies.pdf";
            }
            axios
                .post("/AccountingAndFees/getChildList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((res.data.status = "SUCCESS")) {
                            this.children = res.data.learners;
                            this.academic_year_list = res.data.academicyearlist;
                        } else {
                            alert(res.data.status_reason);
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                    //alert("done")
                });
        },
    };
</script>

<style scoped>
   
    td,
    th {
        border: 1px solid #ccc;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    .scroll {
        overflow-x: scroll;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .noborder {
        border: none;
    }
    .noborder:hover {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
    }
    .text-color {
        font-weight: bold;
        color: red;
    }
    .text-color2 {
        font-weight: bold;
        color: darkseagreen;
    }
    .text-color1 {
        font-weight: bold;
        color: darkblue;
    }

    .btn-grad {
        /* background-image: linear-gradient(to right, #abbaab 0%, #ffffff  51%, #abbaab  100%) */
    }
    .btn-grad {
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: black;
        box-shadow: 0 0 20px rgb(190, 187, 187);
        border-radius: 10px;
        display: block;
    }

    .btn-grad:hover {
        background-position: right center; /* change the direction of the change here */
        color: black;
        text-decoration: none;
    }
    .btn1-grad {
        background-image: linear-gradient(to right, #085078 0%, #85d8ce 51%, #085078 100%);
    }
    .btn1-grad {
        text-align: center;
        text-transform: uppercase;
        transition: 0.5s;
        background-size: 200% auto;
        color: white;
        box-shadow: 0 0 20px #eee;
        border-radius: 10px;
        display: block;
    }

    .btn1-grad:hover {
        background-position: right center; /* change the direction of the change here */
        color: #fff;
        text-decoration: none;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .span-mr {
        margin: 1rem !important;
        padding: 0px;
    }
    .flash {
        animation-name: flash;
        animation-duration: 0.9s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-direction: alternate;
        animation-play-state: running;
    }

    @keyframes flash {
        from {
            color: red;
        }
        to {
            color: white;
        }
    }

    @media (max-width: 920px) {
        .button-name {
            /* color: red; */
            white-space: normal;
        }
        .issue-btn {
            display: block;
            word-wrap: break-word;
        }
        .pay-btn {
            display: block;
            word-wrap: break-word;
        }
    }
</style>
